<template>
<div style="position: relative">
    <title-and-edit :currentViewTitle="layout == 'portal' ? 'Fordelsprogrammer' : 'Fordelsprogram'" :layout="layout"/>
    <div v-if="programs.length">
        <div v-if="layout == 'portal'" class="profile__container--content__membershipProgram pt-5">
            <div v-for="membershipProgram in programs" :key="membershipProgram.programName">
                <v-hover v-slot="{ hover }">
                    <div 
                        v-ripple
                        class="d-flex justify-space-between align-center py-2 px-4"
                        :style="hover ? `color: #579FA75C; background-color: ${layout == 'portal' ? '#579FA71F' : 'var(--v-primary-opacity-12)'}; cursor: pointer;` : membershipProgram.isMember ? '' : 'color: var(--v-primary-opacity-60)'"
                        @click="switchComponent(membershipProgram)"
                    >
                        <div :style="layout == 'portal' ? `${!membershipProgram.isMember ? 'color: var(--v-primary-opacity-60)' : 'color: var(--v-primary-base)'}` : 'color: #222222'">
                            <p class="font-weight-bold mb-0">{{membershipProgram.programName}}<span class="font-weight-regular" :class="membershipProgram.isMember ? 'text--secondary' : ''"> {{membershipProgram.isMember ? '' : '(Ikke medlem)'}}</span></p>
                            <p class="mb-0">{{membershipProgram.chain.name}}</p>
                        </div>
                        <p v-if="membershipProgram.isMember" class="profile__container--content__membershipProgram--points mb-0 pr-4">{{membershipProgram.pointsEarned}} p</p>
                    </div>
                </v-hover>
                <hr :class="`profile__container--navigation__${layout == 'portal' ? 'portal-linebreak' : 'linebreak'}`"/>
            </div>
        </div>
        <div v-else>
            <transition v-show="!loading" mode="out-in" name="fade-transition">
                <program-info v-if="programs.length && chainProgram.isMember" :programId="chainProgram.customerProgramId" :layout="layout" @refresh="refresh" :siteId="chainProgram.customer.siteId"></program-info>
                <join-program v-if="programs.length && !chainProgram.isMember" :programId="chainProgram.customerProgramId" :layout="layout" @refresh="refresh" :siteId="chainProgram.customer.siteId"></join-program>
            </transition>
        </div>
    </div>
    <div v-else>
        <div v-if="loading">
            <v-overlay :value="loading" color="white" absolute style="height: 600px">
                <v-progress-circular
                    color="var(--v-primary-base)"
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </div>
        <no-content v-else title="Ingen fordelsprogram tilgjengelig i dine salonger!" icon="fxt-vip-fist" :redirectUrl="portalUrl()" buttonText="Finn din salong" :layout="layout"/>
    </div>
</div>
</template>

<script>
import { TitleAndEdit, NoContent } from '../../../Common/CommonComponents'
import JoinProgram from '../MembershipProgram/components/JoinProgram.vue'
import ProgramInfo from '../MembershipProgram/components/ProgramInfo.vue'
import ProfileSvc from '../../../../services/profile-svc';
let profileSvc = null;
export default {
    components: { ProgramInfo, JoinProgram, TitleAndEdit, NoContent },
    props: {
        layout: {
            required: true,
            default: 'chain',
            type: String
        },
    },
    data: () => ({
        programs: [],
        loading: false,
    }),
    computed: {
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        chainProgram() {
            return this.programs.find(x => x.chainId == this.$store.getters["cmsConfigHomepage/getChainId"] ? this.$store.getters["cmsConfigHomepage/getChainId"] : this.$route.params.chainId)
        }
    },
    methods: {
       switchComponent(program) {
            if (this.layout == 'chain') {
                program.isMember 
                ? this.$router.replace({query: {id: program.customerProgramId, title: 'info-fordelsprogram', siteId: program.customer.siteId }, params: {program: program}}) 
                : this.$router.replace({query: {id: program.customerProgramId, title: 'bli-med-i-fordelsprogram', siteId: program.customer.siteId }, params: {program: program}})
            } else {
                program.isMember 
                ? this.$router.push({name: 'Info fordelsprogram', params: {id: program.customerProgramId, program: program}, query: {siteId: program.customer.siteId}}) 
                : this.$router.push({name: 'Bli med i fordelsprogram', params: {id: program.customerProgramId, program: program}, query: {siteId: program.customer.siteId}})
            }
        },
        async refresh() {
            this.programs = await profileSvc.GetCustomerPrograms(this.bookingApi, this.layout == 'portal' ? null : this.$store.getters["cmsConfigHomepage/getChainId"] ? this.$store.getters["cmsConfigHomepage/getChainId"] : this.$route.params.chainId)
        },
        portalUrl() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_URL : this.$config.PORTAL_URL
        },
    },
    async created() {
        this.loading = true
		profileSvc = await ProfileSvc(this.$axios);
        this.programs = await profileSvc.GetCustomerPrograms(this.bookingApi, this.layout == 'portal' ? null : this.$store.getters["cmsConfigHomepage/getChainId"] ? this.$store.getters["cmsConfigHomepage/getChainId"] : this.$route.params.chainId)
        this.loading = false
    },
    beforeDestroy() {
		profileSvc = null
	}
}
</script>